import { combineReducers } from 'redux'
import { routerReducer } from 'react-router-redux'
import { 
  staticContent, 
  backgrounds,
  names,
  texts, 
  text
} from './ContentReducer'

import { postcard } from './PostcardReducer'

const AppReducers = combineReducers({
  staticContent,
  backgrounds,
  names,
  texts,
  text,
  postcard,
  routing: routerReducer
})

export default AppReducers;



// WEBPACK FOOTER //
// ./src/reducers/AppReducers.js